import { AuthService, User } from './../user/auth.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { UnsplashImageService } from '../unsplash/unsplash.service';
import { Result } from '../unsplash/unsplash.response';
import { RegistryService } from '../registry/registry.service';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute } from '@angular/router';

import { UserService } from '../user/user.service';
@Component({
  selector: 'app-registry-popup',
  templateUrl: './registry-popup.component.html',
  styleUrls: ['./registry-popup.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  host: {
    '(document:keydown)': 'handleKeyboardEvents($event)'
  }
})

export class RegistryPopupComponent implements OnInit {
  private showPopup = false;
  private user: User;
  url: string;
  constructor(private _unsplashImageService: UnsplashImageService,
    private _registryService: RegistryService,
    private router: Router,
    private _authService: AuthService,
    private _registryFirebaseService: RegistryFirebaseService
  ) {

    console.log('loaded');



  }

  handleKeyboardEvents(event: any) {

    if (event.keyCode === 27) {

      this.close('/registry');
    }

  }




  ngOnInit() {

    let body = document.getElementsByTagName('body')[0];
    //
    // body.style.overflow = "hidden";

    this._authService.user.subscribe(user => {
      this.user = user;
      if (user) {
        this._registryFirebaseService.setRegistryForUser(user);
        const dismiss = user.dismissCreatePopup;
        if (dismiss) {


          //this.router.navigate([this.url]);
        }
      }

    });


  }



  close(url: string) {

    window.scrollTo(0, 0);
    let body = document.getElementsByTagName('body')[0];
    body.style.overflow = "auto";
    this.user.dismissCreatePopup = true;
    this._registryFirebaseService.updateUser(this.user);
    this.router.navigate([url]);
  }

}



// WEBPACK FOOTER //
// ./src/app/registry-popup/registry-popup.component.ts